import moment from 'moment';

export const CHILD_GALLERY_SORT_MODE = {
  END_TIME_ASC: "end_time_asc",
  CREATED_AT_ASC: "created_at_asc",
};
export const DEFAULT_CHILD_GALLERY_SORT_MODE = CHILD_GALLERY_SORT_MODE.END_TIME_ASC;
export const CHILD_GALLERY_SORT_STORAGE_PREFIX = "filev2_tree_child_sort_order_";

export const GALLERY_TIME_FIELD_ALIASES = {
  created_at: [
    "created_at",
    "createtime",
    "create_time",
    "createdAt",
    "add_time",
    "addtime",
  ],
  end_time: ["end_time", "endtime"],
  start_time: ["start_time", "starttime"],
};

export const getGalleryTimeSortValue = (value, fallback = Number.MAX_SAFE_INTEGER) => {
  const currentMoment = moment(value);
  return currentMoment.isValid() ? currentMoment.valueOf() : fallback;
};

export const getGalleryFieldTimeSortValue = (
  gallery = {},
  field,
  fallback = Number.MAX_SAFE_INTEGER
) => {
  const fieldAliases = GALLERY_TIME_FIELD_ALIASES[field] || [field];

  for (let index = 0; index < fieldAliases.length; index += 1) {
    const sortValue = getGalleryTimeSortValue(gallery?.[fieldAliases[index]], null);

    if (sortValue !== null) {
      return sortValue;
    }
  }

  return fallback;
};

export const sortChildrenByTimeFieldAsc = (
  children = [],
  primaryField,
  secondaryField
) => {
  return [...children].sort((a, b) => {
    const primaryDiff =
      getGalleryFieldTimeSortValue(a, primaryField) -
      getGalleryFieldTimeSortValue(b, primaryField);

    if (primaryDiff !== 0) {
      return primaryDiff;
    }

    if (secondaryField) {
      const secondaryDiff =
        getGalleryFieldTimeSortValue(a, secondaryField) -
        getGalleryFieldTimeSortValue(b, secondaryField);

      if (secondaryDiff !== 0) {
        return secondaryDiff;
      }
    }

    return Number(a?.id || 0) - Number(b?.id || 0);
  });
};

export const sortChildrenByEndTimeAsc = (children = []) => {
  return sortChildrenByTimeFieldAsc(children, "end_time", "created_at");
};

export const sortChildrenByCreatedTimeAsc = (children = []) => {
  return sortChildrenByTimeFieldAsc(children, "created_at");
};

export const CHILD_GALLERY_SORT_OPTIONS = [
  {
    key: CHILD_GALLERY_SORT_MODE.END_TIME_ASC,
    label: "按结束时间正序",
    isDefault: true,
    sorter: sortChildrenByEndTimeAsc,
  },
  {
    key: CHILD_GALLERY_SORT_MODE.CREATED_AT_ASC,
    label: "按创建时间正序",
    sorter: sortChildrenByCreatedTimeAsc,
  },
];

export const getCurrentOrderId = (props = {}) => {
  return props?.gallery?.orderid || props?.order?.id || props?.galleryid || "";
};

export const getChildGallerySortStorageKey = (orderId) => {
  return orderId ? `${CHILD_GALLERY_SORT_STORAGE_PREFIX}${orderId}` : "";
};

export const getChildGallerySortOption = (sortMode) => {
  return (
    CHILD_GALLERY_SORT_OPTIONS.find((item) => item.key === sortMode) ||
    CHILD_GALLERY_SORT_OPTIONS[0]
  );
};

//  sortMode = end_time_asc | created_at_asc
// return sort-ascending|sort-descending
export const getChildGallerySortIconType = (sortMode) => {
  const option = getChildGallerySortOption(sortMode);
  return option.key === CHILD_GALLERY_SORT_MODE.END_TIME_ASC
    ? "sort-descending"
    : "sort-ascending";
};

export const sortChildrenByMode = (
  children = [],
  sortMode = DEFAULT_CHILD_GALLERY_SORT_MODE
) => {
  return getChildGallerySortOption(sortMode).sorter(children);
};

export const getStoredChildGallerySortMode = (orderId) => {
  try {
    const sortMode = window.localStorage.getItem(
      getChildGallerySortStorageKey(orderId)
    );

    return CHILD_GALLERY_SORT_OPTIONS.some((item) => item.key === sortMode)
      ? sortMode
      : DEFAULT_CHILD_GALLERY_SORT_MODE;
  } catch (error) {
    return DEFAULT_CHILD_GALLERY_SORT_MODE;
  }
};

export const persistChildGallerySortMode = (orderId, sortMode) => {
  const storageKey = getChildGallerySortStorageKey(orderId);

  if (!storageKey) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, sortMode);
  } catch (error) {}
};

// 弹窗、管理树共用同一订单下的排序偏好。
export const sortGalleryChildren = (children, orderId) =>
  sortChildrenByMode(children || [], getStoredChildGallerySortMode(orderId));

// 品控相册与 CRM 不同域名，通过打开链接传递当前排序方式。
export const withGallerySort = (url, orderId) =>
  `${url}${url.indexOf('?') >= 0 ? '&' : '?'}gallery_sort=${getStoredChildGallerySortMode(orderId)}`;



// WEBPACK FOOTER //
// ./src/util/gallery-sort.js